import React, { useEffect, useState } from "react";
import "./SettlementReport.css";
import { useSelector } from "react-redux";
import { getMerchantSettlement } from "../../../config/LiveApi";
import { toast } from "react-toastify";
import { FcCheckmark, FcMoneyTransfer } from "react-icons/fc";
import Modal from "./ModalPaid";
import ExcelDownloader from "./ExcelDownloader";
import DateFilter from "../../../components/common/DateFilter";

const SettlementTable = () => {
  const token = useSelector((store) => store.userReducer.token);
  const userId = useSelector((store) => store.userReducer.userId);
  const role = useSelector((store) => store.userReducer.role);

  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState({ open: false, data: null });

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const getSettlementData = async (start = startDate, end = endDate) => {
    setLoading(true);
    try {
      const response = await getMerchantSettlement(token, start, end);

      toast.success(response.message || "Data fetched successfully!", {
        autoClose: 1000,
      });

      setTableData(response.data?.data || []);
    } catch (err) {
      console.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (token) {
      getSettlementData();
    }
  }, [token, startDate, endDate]);

  const handleDateChange = (start, end) => {
    setStartDate(start);
    setEndDate(end);
    getSettlementData(start, end);
  };

  return (
    <>
      <div className="provider-settlement-report-container">
        <div className="provider-table-head">
          <div className="provider-settlement-report-title">
            Merchant Settlement
          </div>

          <ExcelDownloader
            data={tableData}
            role={role}
            fileName="Merchant_Settlement"
          />
        </div>

        {/*  REPLACED CALENDAR WITH COMMON COMPONENT */}
        <DateFilter onDateChange={handleDateChange} />

        <table className="provider-settlement-report-table">
          <thead>
            <tr>
              {role !== "admin" && role !== "subAdmin" && (
                <th>Merchant Name</th>
              )}
              <th>Total Settlement Amount</th>
              <th>Wallet Amount</th>
              <th>Rolling Reserve Amount</th>
              {role !== "admin" && role !== "subAdmin" && (
                <th>Fund Difference</th>
              )}
              <th>Settlement Time Range</th>
              <th>Settled Date</th>
              <th>Status</th>
              {role !== "admin" && role !== "subAdmin" && (
                <>
                  <th>Pay Amount</th>
                  <th>Direct Pay</th>
                </>
              )}
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan="10">Loading...</td>
              </tr>
            ) : tableData.length > 0 ? (
              tableData.map((reportData, i) => (
                <tr
                  key={i}
                  className={reportData?.status <= 0 ? "highlight-row-red" : ""}
                >
                  {role !== "admin" && role !== "subAdmin" && (
                    <td>{reportData?.alias || reportData?.userId}</td>
                  )}

                  <td>
                    ₹ {Number(reportData?.settlementAmount || 0).toFixed(2)}
                  </td>

                  <td>
                    ₹{" "}
                    {reportData?.status
                      ? Number(reportData?.paidAmount || 0).toFixed(2)
                      : "0.00"}
                  </td>

                  <td>₹ {Number(reportData?.rrAmount || 0).toFixed(2)}</td>

                  {role !== "admin" && role !== "subAdmin" && (
                    <td>
                      ₹{" "}
                      {Number(
                        (reportData?.settlementAmount || 0) -
                          (reportData?.paidAmount || 0)
                      ).toFixed(2)}
                    </td>
                  )}

                  <td>
                    {reportData?.settlementTimeRange || "N/A"}
                  </td>

                  <td>
                    {new Date(reportData.settledDate).toLocaleString("en-GB")}
                  </td>

                  <td>{reportData?.status ? "SUCCESS" : "PENDING"}</td>

                  {role !== "admin" && role !== "subAdmin" && (
                    <td>
                      <FcMoneyTransfer
                        size={25}
                        onClick={() =>
                          setIsModalOpen({
                            open: true,
                            data: reportData,
                            type: "manual",
                          })
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </td>
                  )}

                  {role !== "admin" && role !== "subAdmin" && (
                    <td>
                      <FcCheckmark
                        size={25}
                        onClick={() =>
                          setIsModalOpen({
                            open: true,
                            data: reportData,
                            type: "direct",
                          })
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="10">No Data Found</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {isModalOpen.open && (
        <Modal
          onClose={() => setIsModalOpen({ open: false, data: null })}
          reportData={isModalOpen.data}
          paidAmount={isModalOpen.paidAmount}
          type={isModalOpen.type}
          refreshTableData={getSettlementData}
          name={isModalOpen.data?.name}
        />
      )}
    </>
  );
};


export default SettlementTable;